import { Component, EventEmitter, Output } from "@angular/core";
var HTML_TEMPLATE = "\n <div class=\"od-sign-in-info\" (click)=\"_handleClose()\">\n    <div class=\"od-sign-in-info-wrapper\">\n      <div class=\"od-sign-in-info-inner\">\n          <div class=\"od-sign-in-info-inner-header\">\n            <div class=\"od-sign-in-info-close\" (click)=\"_handleClose()\">X</div>\n           </div>\n          <div class=\"od-sign-in-info-body\" (click)=\"_handlePrevent($event)\">\n            <h1>{{'SignInInfo.header'| translate}}</h1>\n            <ul>\n              <li>{{'SignInInfo.emailCorrect'| translate}}</li>\n              <li>{{'SignInInfo.emailSpam'| translate}}</li>\n              <li>{{'SignInInfo.accountExists'| translate}}</li>\n              <li>{{'SignInInfo.accountConfirmedRegistered'| translate}}</li>\n            </ul>\n          </div>\n        </div>\n    </div>\n  </div>\n";
var CSS_STYLE = "\n.od-sign-in-info {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.3);\n  z-index: 99;\n}\n\n.od-sign-in-info h1 {\n  font-size: 19px;\n}\n\n.od-sign-in-info-wrapper {\n  width: 100%;\n  flex-grow: 1;\n  place-items: center center;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.od-sign-in-info-inner {\n  border: solid 1px #a4a5a6;\n  padding: 12px;\n  margin-bottom: 40px;\n  width: 100%;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  background-color: #FFFFFF;\n  flex-direction: column;\n  align-items: center;\n  max-width: 377px;\n}\n\n.od-sign-in-info-inner .od-sign-in-info-inner-header {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: end;\n}\n\n.od-sign-in-info-body {\n  padding: 0 20px 20px;\n}\n\n.od-sign-in-info-body li {\n  padding-top: 8px;\n}\n\n.od-sign-in-info-close {\n  cursor: pointer;\n}\n";
var SignInInfo = /** @class */ (function () {
    function SignInInfo() {
        this.onClose = new EventEmitter();
    }
    SignInInfo.prototype._handleClose = function () {
        this.onClose.emit();
    };
    SignInInfo.prototype._handlePrevent = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    SignInInfo.decorators = [
        { type: Component, args: [{
                    selector: "od-sign-in-info",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    SignInInfo.ctorParameters = function () { return []; };
    SignInInfo.propDecorators = {
        "onClose": [{ type: Output },],
    };
    return SignInInfo;
}());
export { SignInInfo };
//# sourceMappingURL=sign-in-info.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/sign/sign-in-info.js
// module id = 983
// module chunks = 14